var map = {
	"./fsoel-rms-home-keyvisual.jpg": "BanV",
	"./fsoel_logo.svg": "J4sF",
	"./icon_delete.svg": "TldX",
	"./icon_upload.svg": "nIqn",
	"./light_green.png": "xQ16",
	"./light_red.png": "Nqqq",
	"./light_yellow.png": "4S3G",
	"./logo.png": "nWR2",
	"./pdf-fsoel-bg.jpg": "RTLw",
	"./pdf-sav-bg.jpg": "FJOo",
	"./pdf-vkb-bg.jpg": "Npyq",
	"./pdf_spk_verbundhinweis.svg": "hOCq",
	"./pdf_vkb_logo.svg": "Hser",
	"./sav-rms-home-keyvisual.jpg": "3SIb",
	"./sav_logo.svg": "kx+s",
	"./vkb-rms-home-keyvisual.jpg": "rm7c",
	"./vkb_logo.svg": "cEes"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dYTa";